import React from "react";
import { Mail, Linkedin, Twitter, Heart, Facebook, Instagram, Youtube, MapPin, ArrowUp } from "lucide-react";
import { FaTiktok } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0f172a] text-gray-300">
      {/* Top Border Accent */}
      <div className="h-1 bg-gradient-to-r from-yellow-600 via-amber-400 to-yellow-600"></div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-white tracking-tight">
              OYEKA <span className="text-yellow-500">Amara</span> Kate
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs text-justify">
              Finance & Tax Expert, Strategic Leader, and Author dedicated to driving growth, governance, and empowering the next generation of leaders.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-yellow-500 hover:text-yellow-400 transition-colors text-sm font-semibold uppercase tracking-widest"
            >
              Back to Top <ArrowUp size={16} />
            </button>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Quick Links</h4>
            <ul className="space-y-4">
              <FooterLink href="/about" label="About" />
              <FooterLink href="/books" label="My Book: The Wait Work" />
              <FooterLink href="/presentations" label="Resources & Presentations" />
              <FooterLink href="/foundation" label="OWEF Foundation" />
              <FooterLink href="/inthepress" label="Media & In The Press" />
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 group">
                <Mail className="text-yellow-500 mt-1 flex-shrink-0 group-hover:scale-110 transition-transform" size={18} />
                <a href="mailto:bookamaraoyeka@gmail.com" className="hover:text-white transition-colors">bookamaraoyeka@gmail.com</a>
              </li>
              <li className="flex items-start gap-3 group">
                <MapPin className="text-yellow-500 mt-1 flex-shrink-0 group-hover:scale-110 transition-transform" size={18} />
                <span>Abuja / Lagos, Nigeria</span>
              </li>
            </ul>
          </div>

          {/* Social Column */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">Follow Me</h4>
            <p className="text-gray-400 text-sm mb-6">Stay updated with my latest insights and speaking engagements.</p>
            <div className="flex flex-wrap gap-3">
              <SocialIcon href="https://www.linkedin.com/in/oyeka-amara-kate-b-sc-m-sc-fca-fcti-a9a6a91aa/" icon={<Linkedin size={18} />} />
              <SocialIcon href="https://x.com/amacecekate" icon={<Twitter size={18} />} />
              <SocialIcon href="https://www.facebook.com/ama.kate.3110" icon={<Facebook size={18} />} />
              <SocialIcon href="https://www.instagram.com/officialkate_kenstar/" icon={<Instagram size={18} />} />
              <SocialIcon href="https://www.youtube.com/@Thegreenmicrophone-byAK" icon={<Youtube size={18} />} />
              <SocialIcon href="https://www.tiktok.com/@officialkate_kenstar" icon={<FaTiktok size={16} />} />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Legal Bar */}
      <div className="border-t border-gray-800/50 bg-[#0a1120] py-8">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-gray-500">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6">
              <span>&copy; {currentYear} OYEKA Amara Kate. All Rights Reserved.</span>
              <a href="https://www.orbstechs.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500 transition-colors">
                Partner with <span className="text-gray-400 font-bold">Orbs Technologies</span>
              </a>
            </div>
            <div className="flex items-center gap-2 font-medium">
              Made with <Heart size={14} className="text-red-500 animate-pulse" /> for Global Impact
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterLink = ({ href, label }) => (
  <li>
    <a href={href} className="text-gray-400 hover:text-yellow-500 hover:translate-x-2 transition-all inline-block text-sm">
      {label}
    </a>
  </li>
);

const SocialIcon = ({ href, icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 rounded-lg bg-gray-800/50 flex items-center justify-center text-gray-400 hover:bg-yellow-600 hover:text-white hover:-translate-y-1 transition-all duration-300 shadow-lg border border-gray-700/30"
  >
    {icon}
  </a>
);

export default Footer;
